// IE 2026 10 29 / ODOO-5800 (ie-dm7: Alt+Enter — один select)
// Находка пробы p089c (dev02, отчёт Supply & Demand Balance): одно нажатие Alt+Enter на гриде отчёта слало ДВА select виджета, первый
// обрывался вторым (abort + del_last_backend_action → бэк отвечал на него 204 «POST CANCELLED»). Корень — два слушателя ОДНОГО keydown:
//   App.vue handleKeydown (document, capture-фаза) → store.runActionForHotKey(activeWIDGET, 'Alt Enter') — без события (не гасит его);
//   AttrGrid.vue (flex.hostElement, bubble-фаза)    → store.runActionForHotKey(this.WIDGET, 'Alt Enter') — то же действие того же виджета.
// Кнопка «Update data» (pi-sync) — один вызов, один select. Так же дублировался Shift+Alt+Enter (Reload).
// Решение: «одно событие клавиатуры → одно действие горячей клавиши на виджет». Слушатели передают событие (opts.onceEvent), стор перед
// выполнением найденного действия занимает пару (виджет, клавиша) на ЭТОМ событии; повторный вызов с тем же событием и тем же виджетом —
// без запроса (клавиша считается обработанной). Другой виджет на том же событии (грид дочернего виджета при ином activeWIDGET) — как прежде.
// Выключатель fe.ux.hotkeyOnce (дефолт ВКЛ; false — прежнее: оба слушателя шлют своё). Замер: window.hotkeyOnce.stats() — claimed / skipped.
// Чистые функции без DOM — tests/unit/hotkeyOnce.test.mjs
export const HOTKEY_ONCE_FLAG = 'fe.ux.hotkeyOnce'   // IE 2026 10 29 / ODOO-5800

const MARK = '__wsHotkeyOnce'
const stats = { claimed: 0, skipped: 0, last: null }

export function hotkeyOnce_on(setting) {   // чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(HOTKEY_ONCE_FLAG, true) !== false : true } catch (e) { return true }
}

const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase()
const sameWidget = (a, b) => a === b || (a != null && b != null && a.id != null && a.id === b.id)

// true — действие выполнять (первый вызов для пары виджет + клавиша на этом событии, либо флаг выключен / события нет);
// false — это событие уже выполнило ту же клавишу на том же виджете (второй слушатель того же keydown)
export function hotkeyOnce_claim(evt, WIDGET, hotkey, flagOn = true) {
    if (flagOn === false || !evt || typeof evt !== 'object') return true
    let seen = evt[MARK]
    if (!Array.isArray(seen)) {
        try {
            Object.defineProperty(evt, MARK, { value: [], configurable: true, enumerable: false, writable: false })
            seen = evt[MARK]
        } catch (e) { return true }   // событие заморожено — как прежде
        if (!Array.isArray(seen)) return true
    }
    const k = norm(hotkey)
    if (seen.some(s => s.k === k && sameWidget(s.w, WIDGET))) {
        stats.skipped++
        stats.last = { hotkey: k, widget: WIDGET?.id ?? null, at: Date.now() }
        return false
    }
    seen.push({ k, w: WIDGET })
    stats.claimed++
    return true
}

export function hotkeyOnce_stats() { return { ...stats } }
export function hotkeyOnce_resetStats() { stats.claimed = 0; stats.skipped = 0; stats.last = null }

// консоль: window.hotkeyOnce.stats() / .reset() — сколько нажатий занято и сколько повторных вызовов того же события погашено
try { if (typeof window !== 'undefined') window.hotkeyOnce = { stats: hotkeyOnce_stats, reset: hotkeyOnce_resetStats } } catch (e) { /* нет window */ }   // IE 2026 10 29 / ODOO-5800
